import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import socialProviderName from '../../helpers/socialProviderName';
import truncateEmail from '../../helpers/truncateEmail';
import Message from '../../../common/message/Message';
import NonBreakingHyphen from '../../../common/nonbreakinghyphen/NonBreakingHyphen';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_LINK_TITLE,
	ONBOARDING_LINK_NO_THANKS,
	ONBOARDING_LINK_TEXT_VIDEOLAND,
	ONBOARDING_LINK_TEXT_RTL,
	ONBOARDING_LINK_TEXT_SOCIAL,
	ONBOARDING_LINK_CTA,
	ONBOARDING_LOGIN_EMAIL,
} from '../../../../constants/Copy';
import AccountNavLink from '../../../common/links/AccountNavLink';
import { ROUTE_LOGIN_EMAIL, ROUTE_LOGIN_LINK } from '../../../../constants/Routes';

import './LinkNotification.scss';

const LinkNotification = ({ email, loginProvider, missingFields }) => {
	const isRtlAccount = missingFields && missingFields.indexOf('firstVisitVideoland') >= 0;
	return (
		<Fragment>
			<div className="onboarding-link-notification">
				<Heading>
					<NonBreakingHyphen message={ONBOARDING_LINK_TITLE} />
				</Heading>
				<p className="onboarding__text">
					<Message
						message={isRtlAccount ? ONBOARDING_LINK_TEXT_RTL : ONBOARDING_LINK_TEXT_VIDEOLAND}
						values={{
							email: <strong>{truncateEmail(email, 33)}</strong>,
						}}
					/>
				</p>
				<p className="onboarding__text">
					<Message
						message={ONBOARDING_LINK_TEXT_SOCIAL}
						values={{ provider: socialProviderName(loginProvider) }}
					/>
				</p>
				<Button onClick={ROUTE_LOGIN_LINK}>
					<Message
						message={ONBOARDING_LINK_CTA}
						values={{ provider: socialProviderName(loginProvider) }}
					/>
				</Button>
			</div>
			<AccountNavLink>
				{ONBOARDING_LINK_NO_THANKS}{' '}
				<Link className="onboarding__link" to={ROUTE_LOGIN_EMAIL}>
					{ONBOARDING_LOGIN_EMAIL}
				</Link>
			</AccountNavLink>
		</Fragment>
	);
};

LinkNotification.propTypes = {
	email: PropTypes.string.isRequired,
	loginProvider: PropTypes.string.isRequired,
};

export default LinkNotification;
